import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../../config.js";
import qs from "query-string";
import { prepareHeader } from "../../../utils/headerHandler.js";
import { Translate, TranslateFunction } from "../../../utils/Translate.js";

import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Alert,
} from "reactstrap";

class Recover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToLogin: false,
      passr: true,
      passview: false,
      passviewRepeat: false,
      passwordErrors: [],
      errortype: "",
    };

    this.passwordRef = React.createRef();
    this.rpasswordRef = React.createRef();
  }

  componentDidMount() {}

  validatePasswordSecurity = (password) => {
    const errors = [];
    if (password.length < 8) errors.push(TranslateFunction("Recover-Pass Min Length"));
    if (!/[a-z]/.test(password)) errors.push(TranslateFunction("Recover-Pass Lowercase"));
    if (!/[A-Z]/.test(password)) errors.push(TranslateFunction("Recover-Pass Uppercase"));
    if (!/[0-9]/.test(password)) errors.push(TranslateFunction("Recover-Pass Number"));
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password))
      errors.push(TranslateFunction("Recover-Pass Special"));
    return errors;
  };

  automaticPasswordValidation = (password) => {
    this.setState({ errortype: "" });
    if (password === "") {
      this.setState({ passwordErrors: [] });
    } else {
      const errors = this.validatePasswordSecurity(password);
      this.setState({ passwordErrors: errors });
    }
  };

  togglePassView = () => {
    this.setState((prev) => ({ passview: !prev.passview }));
  };

  togglePassViewRepeat = () => {
    this.setState((prev) => ({ passviewRepeat: !prev.passviewRepeat }));
  };

  handleResetPassword = (e) => {
    e.preventDefault();

    const password = this.passwordRef.current?.value.trim() || "";
    const repeatPassword = this.rpasswordRef.current?.value.trim() || "";

    if (!password) {
      this.setState({ errortype: "pass" });
      return;
    }

    if (!repeatPassword) {
      this.setState({ passr: false });
      return;
    }

    const passwordErrors = this.validatePasswordSecurity(password);
    if (passwordErrors.length > 0) {
      this.setState({ passwordErrors });
      return;
    }

    if (password !== repeatPassword) {
      this.setState({ passr: false, passwordErrors: [] });
      return;
    }

    this.setState({ passr: true, passwordErrors: [] });

    const token = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).token;

    let data = qs.stringify({
      token: token,
      password: password,
    });

    const header = prepareHeader({ });
    header['Content-Type'] = 'application/x-www-form-urlencoded';
    axios
      .post(`${config.DOMAIN}users/passrecover`, data, {
        headers: header,
      })
      .then((res) => {
        Swal.fire({
          title: TranslateFunction("Recover-Password Updated Title"),
          text: TranslateFunction("Recover-Password Updated Text"),
          icon: "success",
          confirmButtonText: TranslateFunction("Recover-Confirm Button"),
        }).then(() => {
          this.setState({ redirectToLogin: true });
        });
      })
      .catch((error) => {
        console.error(error);
        if (error?.response?.status === 400) {
          Swal.fire("Error", error.response.data.error || TranslateFunction("Recover-Update Error Text"), "error");
        } else {
          Swal.fire("Error", TranslateFunction("Recover-Generic Error Text"), "error");
        }
      });
  };

  render() {
    const {
      redirectToLogin,
      passview,
      passviewRepeat,
      passr,
      passwordErrors,
      errortype,
    } = this.state;

    if (redirectToLogin) {
      return <Redirect to="/login" />;
    }

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="7" lg="6">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form onSubmit={this.handleResetPassword}>
                      <h1><Translate text="Recover-Title" /></h1>
                      <p className="text-muted">
                        <Translate text="Recover-Subtitle" />
                      </p>

                      <InputGroup className="mb-2">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type={passview ? "text" : "password"}
                          placeholder={TranslateFunction("Recover-New Password Placeholder")}
                          autoComplete="new-password"
                          innerRef={this.passwordRef}
                          onChange={(e) => this.automaticPasswordValidation(e.target.value)}
                          invalid={errortype === "pass"}
                        />
                        <InputGroupAddon addonType="append">
                          <Button color="secondary" onClick={this.togglePassView}>
                            <i className={passview ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                          </Button>
                        </InputGroupAddon>
                      </InputGroup>

                      {passwordErrors.length > 0 && (
                        <Alert color="danger" className="p-2 mb-3" style={{ fontSize: "0.85rem" }}>
                          <ul className="mb-0 pl-3">
                            {passwordErrors.map((error, idx) => (
                              <li key={idx}>{error}</li>
                            ))}
                          </ul>
                        </Alert>
                      )}

                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type={passviewRepeat ? "text" : "password"}
                          placeholder={TranslateFunction("Recover-Confirm Password Placeholder")}
                          autoComplete="new-password"
                          innerRef={this.rpasswordRef}
                          invalid={!passr}
                        />
                        <InputGroupAddon addonType="append">
                          <Button color="secondary" onClick={this.togglePassViewRepeat}>
                            <i className={passviewRepeat ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                          </Button>
                        </InputGroupAddon>
                      </InputGroup>

                      {!passr && (
                        <Alert color="danger" className="p-2 mb-3" style={{ fontSize: "0.85rem" }}>
                          <Translate text="Recover-Passwords Mismatch" />
                        </Alert>
                      )}

                      <Row>
                        <Col xs="12">
                          <Button color="primary" block className="px-4">
                            <Translate text="Recover-Submit Button" />
                          </Button>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col xs="12" className="text-center">
                          <Button color="link" href="/login">
                            <Translate text="Recover-Back To Login" />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Recover;
